import React from "react";
import { Helmet } from "react-helmet";
import "../styles/Terms.css";

const Terms = () => {
  return (
    <div className="terms-container">
      {/* SEO Metadata */}
      <Helmet>
        <title>Terms & Conditions - Ghrianghraffy</title>
        <meta name="description" content="Terms & Conditions for using Ghrianghraffy, the secure photo-sharing platform for schools." />
      </Helmet>

      <h1>Terms & Conditions</h1>
      <p>Last updated: January 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>Welcome to Ghrianghraffy! These Terms & Conditions govern your use of our platform, which allows schools and educators to share photos.</p>
      </section>

      <section>
        <h2>3. Photo Sharing & Privacy</h2>
        <p>All photos uploaded remain the property of the respective schools. Ghrianghraffy does not claim ownership of uploaded content.</p>
        <p>Access to photos is restricted to authorized users within a school community.</p>
      </section>

      <section>
        <h2>4. Prohibited Activities</h2>
        <ul>
          <li>Uploading unauthorized or inappropriate content.</li>
          <li>Sharing login credentials or unauthorized access.</li>
          <li>Using the platform for commercial or unlawful purposes.</li>
        </ul>
      </section>

      <section>
        <h2>5. Data Protection & Compliance</h2>
        <p>We comply with the General Data Protection Regulation (GDPR) and data protection laws. All personal data is stored securely and used only for educational and administrative purposes.</p>
      </section>

      <section>
        <h2>6. Liability & Disclaimer</h2>
        <p>While we strive to ensure a secure experience, Ghrianghraffy is not liable for any unauthorized access, data loss, or third-party misuse.</p>
      </section>

      <section>
        <h2>7. Changes to Terms</h2>
        <p>We reserve the right to update these Terms at any time. Users will be notified of significant changes.</p>
      </section>

      <section>
        <h2>8. Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us at <a href="mailto:information@ghrianghraffy.com">information@ghrianghraffy.com</a>.</p>
      </section>
    </div>
  );
};

export default Terms;
